// 委外结算管理
var OutsourceReconciliationManage = function () { return import('~/pages/outsource-manage/outsource-reconciliation-manage.vue'); };
var OutsourceSettleManage = function () { return import('~/pages/outsource-manage/outsource-settle-manage.vue'); };
export default [
    {
        path: '/outer-settle/outsource-reconciliation-manage',
        name: 'outsource-reconciliation-manage',
        component: OutsourceReconciliationManage // 委外对账
    },
    {
        path: '/outer-settle/outsource-settle-manage',
        name: 'outsource-settle-manage',
        component: OutsourceSettleManage // 委外结算单
    }
];
